import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import Badge from "@material-ui/core/Badge";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { NavLink } from "react-router-dom";
import avatar from "../static/img_avatar.png";
import NotificationCard from "./Cards/NotificationCard";
import {
  getProfile,
  fetchUserData,
  getUserRoleCount,
} from "../services/userService";
import { useHistory } from "react-router-dom";
import NotificationServices from "../services/notficationService";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import "./Navbar.css";
import "./SideNavBar.css";
import GenericThemeSwitch from "./GenericThemeSwitch";
import isEmptyObject from "../utils/isEmptyObject";
import { connect, useDispatch, useSelector } from "react-redux";
import { setCurrentUser } from "../redux/user/user.actions";
import FormatQuoteIcon from "@material-ui/icons/FormatQuote";
import TranslateRoundedIcon from "@mui/icons-material/TranslateRounded";
import { getHomeCMS } from "../services/adminServices";
import { withRouter } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Poetlogopen from "../static/POET_Logo_Pen.png";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { matchPath } from "react-router";
import {
  closeLeftNavbar,
  closeRightModalAndOpenLeftNavbar,
  openLeftNavbar,
  openRightModalAndCloseLeftNavbar,
} from "../redux/handleSideNavBarAndModel/handleStatus.action";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {
  setBlogClick,
  setDocumentClick,
} from "../redux/manageClick/manageClick.action";
import { markAllRead } from "../services/notficationService";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import GavelIcon from "@mui/icons-material/Gavel";
import EditNoteIcon from "@mui/icons-material/EditNote";
import ChromeReaderModeIcon from "@mui/icons-material/ChromeReaderMode";
import AssessmentIcon from "@mui/icons-material/Assessment";
import FeedIcon from "@mui/icons-material/Feed";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import { Button } from "@material-ui/core";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import {
  exitScreen,
  fullscreen,
  fullSizeEditor,
  normalSizeEditor,
} from "../redux/manageFullSizeEditor/fullSizeEditor.action";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import { switchRole } from "../services/userService";
import { Modal } from "reactstrap";
import CloseIcon from "@material-ui/icons/Close";
import { toast, ToastContainer } from "react-toastify";
import { getFeatures, getRolesForSwitch } from "../services/roleServices";
import { addUserLogs } from "../services/userLogServices";
import { setNavItemForCoauthor } from "../redux/navClickForCoauthor/navclickForCoauthor.action";
import { getUserLogs } from "../services/userLogServices";
import SubscriptionRequired from "./SubscriptionRequired";
import { useCheckSubscriptionPlanAccess } from "./SubscriptionAccess";
import PoetNewlogopen from "../static/loginlogo.png";
import { setUserFeatures } from "../redux/features/features.action";
import { setSubscriptionPlan } from "../redux/subscriptionPlan/subscriptionPlan.action";
import { setRoleFeatures } from "../redux/roleFeatures/roleFeatures.action";
import { fade } from "@material-ui/core/styles/colorManipulator";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const drawerWidth = 250;
//d
const collapsedDrawerWidth = 70;
const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "blue",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: 10,
  },
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60,
  },
  grow: {
    flexGrow: 1,
  },
  root: {
    display: "flex",
  },
  appBar: {
    backgroundColor: "#ccced1 !important",
    boxShadow: "none",
    zIndex: theme.zIndex.drawer + 1,
    minHeight: "83px",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    minHeight: "83px",
    marginLeft: drawerWidth,
    width: `calc(99% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  topBar: {
    minHeight: "75px",
    padding: "0 24px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    justifyContent: "space-between",
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
  },
  centerSection: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  logoButton: {
    background: "linear-gradient(135deg, #a4bbedff 0%, #83888bff 100%)",
    borderRadius: "12px",
    padding: "8px",
    minWidth: "44px",
    height: "44px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 25px rgba(11, 79, 231, 0.4)",
    },
  },
  brandText: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  mainTitle: {
    color: "#0b4fe7",
    fontWeight: 700,
    fontSize: "1.5rem",
    letterSpacing: "-0.5px",
    lineHeight: 1.2,
  },
  subTitle: {
    color: "#4d4f5c",
    fontSize: "0.75rem",
    fontWeight: 400,
    letterSpacing: "1px",
    textTransform: "uppercase",
  },
  pageTitle: {
    color: "#0b4fe7",
    fontWeight: 700,
    fontSize: "1.8rem",
    letterSpacing: "-0.5px",
    position: "relative",
  },
  pageSubtitle: {
    color: "#4d4f5c",
    fontSize: "0.875rem",
    fontWeight: 300,
    marginTop: theme.spacing(0.5),
  },
  searchBar: {
    position: "relative",
    width: "400px",
  },
  searchInput: {
    width: "100%",
    padding: "12px 20px 12px 48px",
    background: "rgba(255, 255, 255)",
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    color: "#4d4f5c",
    fontSize: "0.9rem",
    fontWeight: 400,
    transition: "all 0.3s ease",
    "&:focus": {
      outline: "none",
      borderColor: "#0b4fe7",
      boxShadow: "0 0 0 3px rgba(11, 79, 231, 0.1)",
    },
    "&::placeholder": {
      color: "#8d8f9c",
    },
  },
  notificationDot: {
    position: "absolute",
    top: "6px",
    right: "6px",
    width: "8px",
    height: "8px",
    background: "linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)",
    borderRadius: "50%",
    border: "2px solid #ccced1",
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  userName: {
    color: "#4d4f5c",
    fontWeight: 600,
    fontSize: "0.9rem",
  },
  userRole: {
    color: "#8d8f9c",
    fontSize: "0.75rem",
    fontWeight: 400,
  },
  // userAvatar: {
  //   width: "40px",
  //   height: "40px",
  //   border: "2px solid #1976d2",
  // },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    position: "relative",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    zIndex: theme.zIndex.drawer,
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      height: "100vh",
      top: 0,
      left: 0,
      zIndex: theme.zIndex.drawer + 2,
      transform: "translateX(-100%)",
      transition: theme.transitions.create("transform", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },
  drawerOpen: {
    width: drawerWidth,
    //   [theme.breakpoints.down("sm")]: {
    //     transform: "translateX(0)",
    //   },
    // },
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      transform: "translateX(0)",
    },
  },
  drawerClose: {
    // overflowX: "hidden",
    // width: theme.spacing(7) + 1,
    // [theme.breakpoints.up("sm")]: {
    //   width: theme.spacing(9) + 1,
    // },
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: collapsedDrawerWidth,
    [theme.breakpoints.up("sm")]: {
      width: collapsedDrawerWidth,
    },
  },
  drawerPaper: {
    background: "linear-gradient(135deg, #000000, #0c7ff3ff)",
    borderRight: "1px solid rgba(255, 255, 255, 0.1)",
    overflow: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerContainer: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },

  // content: {
  //   flexGrow: 1,
  //   padding: theme.spacing(3),
  //   backgroundColor: "#f5f5f5",
  //   minHeight: "100vh",
  // },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // marginLeft: collapsedDrawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
  toolbar: {
    minHeight: "83px",
  },
  activeNavItem: {
    backgroundColor: "#ffffff !important",
    borderLeft: "3px solid #0c7ff3 !important",
    "& $listItemIcon": {
      color: "#0c7ff3",
    },
    "& $listItemText": {
      color: "#0c7ff3",
      fontWeight: 600,
    },
  },
  navItem: {
    borderRadius: "0 12px 12px 0",
    margin: theme.spacing(0.5, 0),
    padding: theme.spacing(1.3, 2),
    borderLeft: "3px solid transparent",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "rgba(255, 255, 255, 0.1)",
      borderLeft: "3px solid rgba(12, 127, 243, 0.5)",
    },
  },
  listItemIcon: {
    minWidth: 48,
    color: "rgba(255, 255, 255, 0.7)",
  },
  listItemText: {
    color: "rgba(255, 255, 255)",
    fontWeight: 500,
    fontSize: "0.9rem",
    transition: "opacity 0.3s ease",
    opacity: 1,
  },
  listItemTextHidden: {
    opacity: 0,
    width: 0,
    overflow: "hidden",
  },
  sideLogo: {
    // padding: theme.spacing(2, 1.5),
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255)",
    flexShrink: 0,
    maxHeight: "83px",
    transition: "padding 0.3s ease",
  },

  sideLogoCollapsed: {
    padding: theme.spacing(2, 0.5),
    justifyContent: "center",
  },

  sideLogoImage: {
    height: "100%",
    transition: "height 0.3s ease",
  },
  sideLogoImageCollapsed: {
    height: "30px",
  },
  menuListContainer: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
  },
  menuItem: {
    padding: theme.spacing(1.5, 2),
    borderRadius: "8px",
    margin: theme.spacing(0.5),
    color: "#4d4f5c",
    "&:hover": {
      background: "rgba(25, 118, 210, 0.1)",
    },
  },
  popoverContent: {
    padding: "8px",
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
  },
  themeSwitch: {
    padding: "4px",
    background: "rgba(25, 118, 210, 0.1)",
    borderRadius: "20px",
  },
  iconButton: {
    "&:hover": {
      backgroundColor: "#B4D9FF",
    },
  },
  notificationBadge: {
    "& .MuiBadge-badge": {
      backgroundColor: "#1976d2",
      color: "#ffffff",
      fontSize: "0.65rem",
      fontWeight: "bold",
      minWidth: 18,
      height: 18,
    },
  },
  dateDisplay: {
    color: "#4d4f5c",
    fontSize: "0.8rem",
    fontWeight: 400,
    letterSpacing: "0.5px",
  },

  actionButton: {
    background: "rgba(25, 118, 210, 0.1)",
    border: "1px solid rgba(25, 118, 210, 0.2)",
    borderRadius: "10px",
    padding: "12px 18px", // Increased from "8px 16px"
    minWidth: "auto",
    color: "#1976d2",
    fontSize: "0.85rem",
    fontWeight: 500,
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    height: "50px", // Add fixed height
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      background: "rgba(25, 118, 210, 0.15)",
      transform: "translateY(-2px)",
    },
  },

  notificationButton: {
    position: "relative",
    background: "rgba(25, 118, 210, 0.1)",
    border: "1px solid rgba(25, 118, 210, 0.2)",
    borderRadius: "10px",
    width: "50px", // Increased from "44px"
    height: "50px", // Increased from "44px"
    color: "#1976d2",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "rgba(25, 118, 210, 0.15)",
      transform: "translateY(-2px)",
    },
  },

  userMenu: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 16px", // Increased from "8px 16px"
    background: "rgba(25, 118, 210, 0.1)",
    border: "1px solid rgba(25, 118, 210, 0.2)",
    borderRadius: "12px",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    height: "60px", // Add fixed height
    "&:hover": {
      background: "rgba(25, 118, 210, 0.15)",
      transform: "translateY(-2px)",
    },
  },

  userAvatar: {
    width: "45px", // Increased from "40px"
    height: "45px", // Increased from "40px"
    border: "2px solid #1976d2",
  },

  // appLogoButton: {
  //   marginRight: "38px",
  //   padding: "8px",
  //   background: "linear-gradient(135deg, #a4bbedff 0%, #83888bff 100%)",
  //   borderRadius: "12px",
  //   minWidth: "40px",
  //   height: "60px",
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  //   transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  //   "&:hover": {
  //     transform: "translateY(-2px)",
  //     boxShadow: "0 8px 25px rgba(11, 79, 231, 0.4)",
  //   },
  //   [theme.breakpoints.down("sm")]: {
  //     marginRight: 0,
  //   },
  // },

  appLogoButton: {
    marginRight: "20px",
    padding: "4px",
    background: "#ffffff", // Changed from gradient to solid white
    borderRadius: "10px",
    minWidth: "50px",
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)", // Added subtle shadow for depth
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 25px rgba(0, 0, 0, 0.12)", // Darker shadow on hover since we removed the blue gradient
      backgroundColor: "#f8f9ff", // Slightly off-white on hover for feedback
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },

  hide: {
    display: "none",
  },
}));

function NewHeader(props) {
  const { isFullSize } = useSelector((state) => state.manageFullSizeEditor);
  const classes = useStyles();
  const [AnchorEl, setAnchorEl] = React.useState(false);
  const [profilePic, setProfilePic] = useState("");
  const currentUser = useSelector((state) => state.user.currentUser);
  const isGuest = localStorage.getItem("is_guest") === "true";
  const [username, setusername] = useState(isGuest ? "Guest" : "");
  const [notifications, setnotifications] = useState([]);
  const [alerts, setalerts] = useState([]);
  const theme = useTheme();
  const [open, setOpen] = React.useState();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [cms, setCms] = useState({});
  const [userData, setuserData] = useState({});
  const [bottomText, setBottomText] = useState("");
  const [selectedMenu, setSelectedMenu] = useState("Professional Editing Tool");
  const userRole = sessionStorage.getItem("Role");
  const [orgName, setOrgName] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();
  const { rightModalOpen, leftNavbarOpen } = useSelector(
    (state) => state.handleModelAndSideBavBar,
  );

  const [popoverOpen, setPopoverOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [showSwitchRolePopup, setShowSwitchRolePopup] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [isRoleChanged, setIsRoleChanged] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [userRoles, setUserRoles] = useState([]);
  const [currentUserRole, setCurrentUserRole] = useState("");
  const accessToSwitchRole = useCheckSubscriptionPlanAccess("Switch User");
  const [subReqOpen, setSubReqOpen] = useState(false);

  // Add state for current date
  const [currentDate, setCurrentDate] = useState("");

  // Function to format date as "DD | YYYY"
  // const formatCurrentDate = () => {
  //   const date = new Date();
  //   const day = date.getDate().toString().padStart(2, "0");
  //   const year = date.getFullYear();
  //   return `${day} | ${year}`;
  // };
  const formatCurrentDate = () => {
    const date = new Date();
    const month = date.toLocaleDateString("en-US", { month: "short" });
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month} ${day} | ${year}`;
  };

  // Update date function to format as "MMM DD | YYYY" (for the existing formatDate function)
  const formatDate = () => {
    const options = { month: "short", day: "numeric", year: "numeric" };
    const date = new Date();
    const month = date.toLocaleDateString("en-US", { month: "short" });
    const day = date.toLocaleDateString("en-US", { day: "numeric" });
    const year = date.toLocaleDateString("en-US", { year: "numeric" });

    return `${month} ${day} | ${year}`;
  };

  useEffect(() => {
    const isGuest = localStorage.getItem("is_guest") === "true";
    if (isGuest && !currentUser) {
      dispatch(
        setCurrentUser({
          _id: "guest",
          username: "Guest",
          Role: "Guest",
          isGuest: true,
        }),
      );
    }
  }, []);

  // Set current date on component mount
  useEffect(() => {
    setCurrentDate(formatCurrentDate());
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth <= 600) {
        handleDrawerClose();
      }
    };

    window.addEventListener("resize", handleResize);

    // Initialize based on current window width
    if (window.innerWidth <= 600) {
      handleDrawerClose();
    }

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchUserdetails = async () => {
    if (localStorage.getItem("is_guest") === "true") return;
    try {
      const userId = sessionStorage.getItem("userId");
      const data = {
        userId,
      };
      const response = await fetchUserData(data);

      if (response?.user) {
        let subscription = response.user.plan;
        dispatch(setCurrentUser(response.user));
        // setCurrentUser(response?.user);
        setUserDetails(response?.user);
        setUserFeatures(subscription?.features);
        sessionStorage.setItem(
          "subscriptionPlan",
          JSON.stringify(response.user?.plan),
        );

        dispatch(setSubscriptionPlan(subscription));
        const featureResponse = await getFeatures(response?.user?._id);
        if (featureResponse) {
          if (featureResponse?.Features) {
            sessionStorage.setItem(
              "Features",
              JSON.stringify(featureResponse?.Features),
            );
            dispatch(setRoleFeatures(featureResponse?.Features));
          }
        }
      }
    } catch (error) {
      console.log("Error while fetching user data.");
    }
  };

  // useEffect(() => {
  //   fetchUserdetails();
  //   fetchAllRoles();
  // }, []);

  useEffect(() => {
    let isMounted = true;

    const init = async () => {
      if (!isMounted) return;

      await fetchUserdetails();
      await fetchAllRoles();
    };

    init();

    return () => {
      isMounted = false;
    };
  }, []);

  const fetchAllUser = async () => {
    let data = {
      orgId: localStorage.getItem("organizationId"),
      userRole: selectedRole,
    };
    const response = await getUserRoleCount(data);
    let Response2 = await countRegularUser(response.data);
    return Response2;
  };

  const countRegularUser = (data) => {
    let allowedUserRole = sessionStorage.getItem("subscriptionPlan");
    let parsedObject = JSON.parse(allowedUserRole);
    if (currentUserRole === "Power User") {
      if (data >= parsedObject.userCounts.regularUser) {
        return false;
      }
    }
    if (currentUserRole === "Regular User") {
      if (data >= parsedObject.userCounts.powerUser) {
        return false;
      }
    }

    return true;
  };

  useEffect(() => {
    if (isRoleChanged) {
      history.push({
        pathname: `/logout`,
      });
    }
  }, [isRoleChanged]);

  const openSwitchRolePopup = () => {
    if (!accessToSwitchRole) {
      setSubReqOpen(true);
    } else {
      setShowSwitchRolePopup(true);
    }
  };

  const closeSwitchRolePopup = () => {
    setShowSwitchRolePopup(false);
  };

  const rolesForSwitch = userRoles?.filter(
    (role, index) => index !== 0 && role !== currentUserRole,
  );

  const fetchAllRoles = async () => {
    try {
      const repsonse = await getRolesForSwitch();
      if (repsonse?.userRoleList) {
        setUserRoles(repsonse?.userRoleList);
      }
    } catch (error) {
      console.log("Error while fetching all roles.");
    }
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const handleRoleSwitch = async () => {
    try {
      if (!selectedRole) {
        return toast.warn("Role selection is required to proceed.");
      }
      let isSwitchAllowed = await fetchAllUser();
      if (!isSwitchAllowed) {
        return toast.error(`${selectedRole} limit is exceeded`);
      }
      const userId = sessionStorage.getItem("userId");

      const data = {
        userId: userId,
        newRole: selectedRole,
      };
      const response = await switchRole(data);
      if (response.status == 200) {
        toast.success(response.message);
        saveUserLogs();
        setIsRoleChanged(true);
        setShowSwitchRolePopup(false);
      } else {
        toast.error("Error in switching role.");
      }
    } catch (error) {
      toast.error("Internal server error.");
    }
  };

  const saveUserLogs = async () => {
    try {
      const data = {
        userId: userDetails._id,
        organizationId: userDetails.organizationId,
        actionType: "switchRole",
        previousRole: currentUserRole,
        newRole: selectedRole,
      };
      const addLogs = await addUserLogs(data);
      if (addLogs.status !== 200) {
        toast.error(addLogs.message);
      }
    } catch (error) {
      toast.error("Error in saving user logs.");
    }
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const mobileView = windowWidth <= 600;

  const togglePopover = () => {
    setPopoverOpen(!popoverOpen);
  };

  useEffect(() => {
    let isMounted = true;
    const fetchProfile = async () => {
      if (!isMounted) return;

      if (isGuest) {
        setusername("Guest");
        setCurrentUserRole("Guest User");
        return;
      }
      try {
        const currentUser = await getProfile();
        if (!isMounted) return;

        setOrgName(currentUser.data.organizationName);
        setCurrentUserRole(currentUser?.data?.userRole);
        setusername(currentUser?.data?.username);
        dispatch(setCurrentUser(currentUser.data));
      } catch (error) {
        console.error("Failed to fetch profile:", error);
      }
    };
    fetchProfile();
    return () => {
      isMounted = false;
    };
  }, [isGuest]);

  useEffect(() => {
    if (mobileView) {
      handleDrawerClose();
    }
  }, []);

  useEffect(() => {
    const currentPath = window.location.pathname;
    const capitalizeFirstLetter = (string) => {
      if (!string) return "";
      return string.charAt(0).toUpperCase() + string.slice(1);
    };

    if (currentPath.includes("/viewmydocuments/")) {
      setSelectedMenu("Documents");
      return;
    }

    const capitalizedUsername = capitalizeFirstLetter(username);
    switch (currentPath) {
      case "/paraphrase":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/dashboard":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/texteditor":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/mydocuments":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/myteam":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/docTags":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/citation":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/plagiarism":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/coauthor":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/Summarizer":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/translator":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/reports":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/faq":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/alerts":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/grammarcheck":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/blogpage":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/accountsettings":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      case "/pricing":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/invoices":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/contactUs":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/chat":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/coauthor-newproject":
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatCurrentDate()}`);
        break;
      case "/mynewdocuments":
        setSelectedMenu(`Hello ${capitalizedUsername}`);
        setBottomText(
          userRole === "Organization" ? `${orgName}` : `${formatCurrentDate()}`,
        );
        break;
      default:
        setSelectedMenu("Professional Editing Tool");
        setBottomText(""); // Clear bottom text for default menu
    }
  }, [username, orgName]);

  useEffect(() => {
    const prevPath = sessionStorage.getItem("previousPath");
    const currPath = location.pathname;

    sessionStorage.setItem(
      "previousPath",
      sessionStorage.getItem("currentPath"),
    );
    sessionStorage.setItem("currentPath", currPath);
  }, [location.pathname]);

  const history = useHistory();

  const markAllNotificationsRead = async () => {
    try {
      if (notifications.notificationsCount < 1) {
        return;
      }

      let details = await markAllRead();
      if (details.status === 200) {
        getNotifications();
      }
    } catch (error) {
      console.error("Error marking all notifications as read:", error.message);
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const getCms = async () => {
    const { currentUser, setCurrentUser } = props;
    if (localStorage.getItem("is_guest") === "true") return;
    let cms = await getHomeCMS();
    setCms(cms.data);
  };

  // useEffect(() => {
  //   async function getUser() {
  //     const { currentUser, setCurrentUser } = props;
  //     if (!JSON.stringify(currentUser)) {
  //       let user = (user = await getProfile());
  //       user = { ...user.data };
  //       setuserData(user);
  //       setCurrentUser(user);
  //     }
  //   }
  //   getUser();
  //   getNotifications();
  //   getAlerts();
  //   displyPic();
  //   getCms();
  // }, [rightModalOpen, leftNavbarOpen]);

  // useEffect(() => {
  //   const { currentUser } = props;
  //   setOpen(currentUser.sidenavOption);
  // }, [props]);

  // useEffect(() => {

  //   console.log("👤 getUser useEffect fired", {
  //     isGuest: localStorage.getItem("is_guest"),
  //   });
  //   async function getUser() {
  //     const { currentUser, setCurrentUser } = props;

  //     // ✅ Never call profile API for guest
  //     if (localStorage.getItem("is_guest") === "true") {
  //       return;
  //     }

  //     // ✅ Only fetch if truly empty
  //    if (!currentUser && !isGuest) {
  //       try {
  //         console.log("❗ getUser calling getProfile");
  //         let user = await getProfile();
  //         user = { ...user.data };
  //         setuserData(user);
  //         setCurrentUser(user);
  //       } catch (e) {
  //         console.log("Profile fetch skipped:", e.message);
  //       }
  //     }
  //   }

  //   getUser();
  //   getNotifications();
  //   getAlerts();
  //   displyPic();
  //   getCms();
  // }, [rightModalOpen, leftNavbarOpen]);

  useEffect(() => {
    console.log("👤 getUser useEffect fired", { currentUser, isGuest });
    let isMounted = true;
    if (isGuest) {
      console.log("🟢 Guest detected — skipping profile fetch");
      return;
    }

    const fetchUser = async () => {
      if (!currentUser) {
        try {
          let user = await getProfile();
          if (!isMounted) return;
          dispatch(setCurrentUser(user.data));
        } catch (e) {
          console.log("Profile fetch skipped:", e.message);
        }
      }
    };

    fetchUser();
    return () => {
      isMounted = false;
    };
  }, [currentUser]);

  useEffect(() => {
    const { currentUser } = props;

    if (currentUser?.sidenavOption) {
      setOpen(currentUser.sidenavOption);
    }
  }, [props.currentUser]);

  const notfication_popover = (
    <Popover id="popover-basic" style={{ zIndex: "9999", minWidth: "400px" }}>
      <Popover.Content
        style={{
          overflowY: "auto",
          maxHeight: "40vh",
          position: "relative",
          minWidth: "400px",
        }}
      >
        <div
          className="notification-div"
          style={{
            position: "sticky",
            top: -7,
            zIndex: 1,
            paddingTop: "5px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <h6>
              <b>Notification</b>
            </h6>
          </div>
          <div>
            <p
              style={{
                color: "#1976d2",
                fontSize: "10px",
                position: "relative",
                bottom: "-4px",
                cursor: "pointer",
              }}
              onClick={() => {
                markAllNotificationsRead();
                togglePopover();
              }}
            >
              Mark all as read
            </p>
          </div>
        </div>
        <hr />
        <NotificationCard data={notifications} />
      </Popover.Content>
    </Popover>
  );

  const handleDrawerOpen = () => {
    setOpen(true);
    dispatch(closeRightModalAndOpenLeftNavbar());
  };

  const handleDrawerClose = () => {
    setOpen(false);
    dispatch(closeLeftNavbar());
  };

  const menuId = "primary-search-account-menu";
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const getAlerts = async () => {
    if (localStorage.getItem("is_guest") === "true") return;
    let alerts = await NotificationServices.getAlerts();
    setalerts(alerts);
  };

  const getNotifications = async () => {
    if (localStorage.getItem("is_guest") === "true") return;
    let notifications = await NotificationServices.getnotifications();
    setnotifications(notifications);
  };

  const handleBlogClick = () => {
    dispatch(setBlogClick());
    dispatch(setNavItemForCoauthor("blogs"));
  };

  const handleDocumentClick = (navItem) => {
    dispatch(setDocumentClick());
    if (navItem == "mydocuments") {
      dispatch(setNavItemForCoauthor("Documents"));
    }
    if (navItem == "grammarcheck") {
      dispatch(setNavItemForCoauthor("grammerChaeck"));
    }
    if (navItem == "coauthor") {
      dispatch(setNavItemForCoauthor("coAuthor"));
    }
  };

  const handleTagsClick = () => {
    dispatch(setNavItemForCoauthor("Tags"));
  };

  const displyPic = async () => {
    console.log("GUEST CHECK", isGuest);
    console.log("🖼️ displyPic called", {
      isGuest: localStorage.getItem("is_guest"),
    });
    if (localStorage.getItem("is_guest") === "true") {
      setProfilePic("");
      setusername("Guest");
      return;
    }
    let user;
    const { currentUser, setCurrentUser } = props;
    if (currentUser && !isEmptyObject(currentUser)) {
      user = { ...currentUser };
      user["status"] = 200;
    } else {
      console.log("❗ About to call getProfile in displyPic");
      user = user = await getProfile();
      console.log("❗ getProfile result:", user);
      user = user.data;
      setCurrentUser(user);
    }
    if (user.status === 200) {
      const { display_picture, username } = user;
      setProfilePic(display_picture);
      setusername(username);
    }
  };

  const mobileMenuId = "primary-search-account-menu-mobile";

  const dropdown_popover = (
    <Popover id="popover-basic" style={{ zIndex: "9999" }}>
      <Popover.Content>
        <NavLink
          to={{ pathname: "/accountsettings" }}
          style={{ color: "black" }}
        >
          <MenuItem
            onClick={handleMenuClose}
            className={isUrlMatch("/accountsettings") && "background-grey"}
          >
            <Typography>Account Settings</Typography>
          </MenuItem>
        </NavLink>
        {props.currentUser &&
          ((props.currentUser.Role === "Organization" &&
            props.currentUser.isAdmin === true) ||
            props.currentUser.Role === "Individual") && (
            <NavLink
              to={{ pathname: "/pricing" }}
              style={{ color: "black", paddingTop: "2px" }}
            >
              <MenuItem
                onClick={handleMenuClose}
                className={isUrlMatch("/pricing") && "background-grey"}
              >
                Subscriptions
              </MenuItem>
            </NavLink>
          )}

        {props.currentUser && props.currentUser.accountType === "Personal" && (
          <NavLink to={{ pathname: "/invoices" }} style={{ color: "black" }}>
            <MenuItem
              onClick={handleMenuClose}
              className={isUrlMatch("/invoices") && "background-grey"}
            >
              Invoices
            </MenuItem>
          </NavLink>
        )}

        <NavLink to={{ pathname: "/contactUs" }} style={{ color: "black" }}>
          <MenuItem onClick={handleMenuClose}>Support</MenuItem>
        </NavLink>
        <NavLink to={{ pathname: "/logout" }} style={{ color: "black" }}>
          <MenuItem onClick={handleMenuClose}>Log Out</MenuItem>
        </NavLink>
      </Popover.Content>
    </Popover>
  );

  function isUrlMatch(path) {
    return matchPath(location.pathname, {
      path,
      exact: true,
      strict: false,
    });
  }

  const getThemeSwitch = () => {
    return (
      <div className={classes.themeSwitch}>
        <GenericThemeSwitch />
      </div>
    );
  };

  const handleMenuSelection = (menuName) => {
    setSelectedMenu(menuName);
  };

  useEffect(() => {
    handleMenuSelection(selectedMenu);
    const container = document.querySelector(".MuiDrawer-paper");
    if (container) {
      if (
        selectedMenu == "Summarizer" ||
        selectedMenu == "Translator" ||
        selectedMenu == "Reports" ||
        selectedMenu == "Tags" ||
        selectedMenu == "Blogs" ||
        selectedMenu == "FAQ"
      ) {
        container.scrollTop = 320;
      } else {
        container.scrollTop = 0;
      }
    }
  }, [selectedMenu]);

  const [isFullscreen, setIsFullscreen] = useState(false);

  const enterFullscreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
    setIsFullscreen(true);
    dispatch(fullscreen());
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setIsFullscreen(false);
    dispatch(exitScreen());
  };

  // const toggleFullscreen = () => {
  //   if (!isFullscreen) {
  //     enterFullscreen();
  //   } else {
  //     exitFullscreen();
  //   }
  // };
  const toggleFullscreen = async () => {
    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen();
        setIsFullscreen(true);
        dispatch(fullscreen());
      } else {
        await document.exitFullscreen();
        setIsFullscreen(false);
        dispatch(exitScreen());
      }
    } catch (error) {
      console.error("Fullscreen error:", error);
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        setIsFullscreen(false);
      } else {
        setIsFullscreen(true);
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: leftNavbarOpen,
        })}
      >
        <Toolbar
          className={classes.toolbar}
          style={{
            padding: 0,
            paddingRight: "20px",
            minHeight: "83px",
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* Logo Button in AppBar - Click to open sidebar */}
          <LightTooltip title="Click to Expand">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.appLogoButton, {
                [classes.hide]: leftNavbarOpen,
              })}
              style={{
                height: "60px",
                width: "65px",
                marginLeft: !leftNavbarOpen ? "5px" : "0",
                position: "relative",
                zIndex: 1000,
                padding: "4px",
              }}
            >
              <img
                alt="logo"
                className="img-fluid lcss"
                src={Poetlogopen}
                style={{
                  height: "60px",
                  width: "65px",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </IconButton>
          </LightTooltip>

          {/* Username and Date Section - Left side after logo */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "24px",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <Typography
                style={{
                  fontSize: "1.6rem",
                  fontWeight: 800,
                  background:
                    "linear-gradient(135deg, #1b2ad7ff 0%, #1b2ad7ff 0%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  color: "transparent",
                  lineHeight: 1.2,
                  letterSpacing: "-0.5px",
                  fontFamily: "'Poppins', 'Segoe UI', sans-serif",
                }}
              >
                Welcome
              </Typography>
              <Typography
                style={{
                  fontSize: "1.6rem",
                  fontWeight: 800,
                  background:
                    "linear-gradient(135deg,  #1b2ad7ff 0%, #1b2ad7ff 0%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  color: "transparent",
                  lineHeight: 1.2,
                  letterSpacing: "-0.5px",
                  fontFamily: "'Poppins', 'Segoe UI', sans-serif",
                }}
              >
                {isGuest ? "Guest" : username}
              </Typography>
            </div>

            <Typography
              style={{
                fontSize: "1.25rem",
                color: "#5c6bc0",
                fontWeight: 500,
                letterSpacing: "0.5px",
                marginTop: "6px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontFamily: "'Inter', 'Roboto', sans-serif",
              }}
            >
              {/* <span style={{ fontSize: "1rem" }}>📅</span> */}
              {currentDate}
            </Typography>
          </div>

          {/* Spacer to push everything else to the right */}
          <div className={classes.grow} style={{ height: "100%" }} />

          {/* Right side actions */}
          <div
            className={classes.rightSection}
            style={{ height: "100%", alignItems: "center" }}
          >
            {/* Fullscreen Toggle */}
            <LightTooltip
              title={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              <IconButton
                className={classes.actionButton}
                onClick={toggleFullscreen}
                style={{ height: "50px" }}
              >
                {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            </LightTooltip>

            {/* Switch Role */}
            {userDetails?.originalRole?.userRole == userRoles[1] && (
              <LightTooltip title={"Switch Role"}>
                <IconButton
                  className={classes.actionButton}
                  onClick={openSwitchRolePopup}
                  style={{ height: "50px" }}
                >
                  <SwitchAccountIcon />
                </IconButton>
              </LightTooltip>
            )}

            <SubscriptionRequired open={subReqOpen} setOpen={setSubReqOpen} />

            {/* Theme Switch */}
            {/* <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
        {getThemeSwitch()}
      </div> */}

            {/* Notifications */}
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              overlay={notfication_popover}
              rootClose={true}
              show={popoverOpen}
            >
              <LightTooltip title="Notifications">
                <IconButton
                  className={classes.notificationButton}
                  onClick={togglePopover}
                  disabled={notifications.notificationsCount < 1}
                  style={{ height: "50px", width: "50px" }}
                >
                  <Badge
                    badgeContent={
                      notifications.notificationsCount > 0
                        ? notifications.notificationsCount
                        : null
                    }
                    color="secondary"
                    className={classes.notificationBadge}
                  >
                    <NotificationsIcon />
                  </Badge>
                  {notifications.notificationsCount > 0 && (
                    <div className={classes.notificationDot} />
                  )}
                </IconButton>
              </LightTooltip>
            </OverlayTrigger>

            {/* User Menu */}
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              overlay={dropdown_popover}
              rootClose={true}
            >
              <div
                className={classes.userMenu}
                style={{ height: "60px", alignItems: "center" }}
              >
                <Avatar
                  src={profilePic || avatar}
                  alt={username}
                  className={classes.userAvatar}
                  style={{ width: "45px", height: "45px" }}
                />
                <div className={classes.userInfo}>
                  <Typography className={classes.userName}>
                    {isGuest ? "Guest" : username}
                  </Typography>
                  <Typography className={classes.userRole}>
                    {isGuest ? "Guest User" : currentUserRole}
                  </Typography>
                </div>
              </div>
            </OverlayTrigger>
          </div>
        </Toolbar>
      </AppBar>

      {/* Switch Role Modal */}
      <Modal
        isOpen={showSwitchRolePopup}
        toggle={() => setShowSwitchRolePopup(!showSwitchRolePopup)}
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "50%",
        }}
      >
        <div style={{ padding: "25px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 style={{ color: "#1976D2", marginBottom: "0px" }}>
              Switch Role
            </h3>
            <CloseIcon
              style={{ color: "red" }}
              onClick={closeSwitchRolePopup}
            />
          </div>

          <div style={{ width: "85%", margin: " 22px auto" }}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="userRole"
                name="userRole"
                value={selectedRole}
                onChange={handleRoleChange}
              >
                {rolesForSwitch.map((role, index) => (
                  <FormControlLabel
                    key={index}
                    value={role}
                    control={<Radio />}
                    label={role}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={handleRoleSwitch}
              style={{ color: "white", backgroundColor: "#1976d2" }}
            >
              Switch
            </Button>
          </div>
        </div>
      </Modal>

      {/* Sidebar Drawer */}
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: leftNavbarOpen,
          [classes.drawerClose]: !leftNavbarOpen,
        })}
        classes={{
          paper: clsx(classes.drawerPaper, {
            [classes.drawerOpen]: leftNavbarOpen,
            [classes.drawerClose]: !leftNavbarOpen,
          }),
        }}
        open={mobileOpen}
        onClose={handleDrawerToggle}
        id="normalsidenav"
      >
        {/* Container for fixed layout */}
        {/* <div className={classes.drawerContainer}> */}
        {/* Logo Section - Fixed at top */}
        {/* <div className={classes.sideLogo}>
            <IconButton
              onClick={handleDrawerClose}
              size="small"
              style={{
                position: "absolute",
                right: 8,
                backgroundColor: fade("#667eea", 0.1),
                color: "#667eea",
              }}
            >
              <ChevronLeftIcon />
            </IconButton> */}
        {/* <img
              alt="logo"
              src={PoetNewlogopen}
              // src={Poetlogopen}
              className={classes.sideLogoImage}
              style={{
                height: "100%",
                marginRight: "50px",
              }}
            /> */}
        {/* </div> */}
        {/* Logo Section - Fixed at top */}
        <div className={classes.drawerContainer}>
          <div className={classes.sideLogo}>
            <IconButton
              onClick={handleDrawerClose}
              size="small"
              style={{
                position: "absolute",
                right: 8,
                backgroundColor: fade("#667eea", 0.1),
                color: "#667eea",
              }}
            >
              <ChevronLeftIcon />
            </IconButton>

            {/* Left side: Logo */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flex: 1,
                gap: "5px",
              }}
            >
              <img
                alt="logo"
                src={Poetlogopen}
                className={classes.sideLogoImage}
                style={{
                  height: "100px",
                  width: "auto",
                  objectFit: "contain",
                }}
              />

              {/* Right side: Text - only visible when sidebar is open */}
              {leftNavbarOpen && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    overflow: "hidden",
                  }}
                >
                  <Typography
                    style={{
                      color: "#0b4fe7",
                      fontWeight: 700,
                      fontSize: "1.4rem",
                      lineHeight: 1.3,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Synthium
                  </Typography>
                  <Typography
                    style={{
                      color: "#4d4f5c",
                      fontSize: "0.95rem",
                      fontWeight: 500,
                      lineHeight: 1.3,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Creative Suite
                  </Typography>
                </div>
              )}
            </div>
          </div>

          {/* Scrollable Menu List */}
          <div className={classes.menuListContainer}>
            <List
              className="drawerMenu pointer"
              id="menuList"
              style={{
                borderTopRightRadius: "50px",
                // padding: "0",
              }}
            >
              <ListItem
                button
                onClick={() => {
                  window.location.href = "/dashboard";
                }}
                // to="/dashboard"
                style={{ textDecoration: "none" }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]: isUrlMatch("/dashboard"),
                  })}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "Dashboard"}
                      placement="right"
                    >
                      <DashboardOutlinedIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      Dashboard
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                button
                // to="/mydocuments"
                style={{ textDecoration: "none" }}
                onClick={() => {
                  handleDocumentClick("mydocuments"); 
                  window.location.href = "/mydocuments"; 
                }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]:
                      isUrlMatch("/mydocuments") ||
                      isUrlMatch("/documentpreview/:id") ||
                      isUrlMatch("/viewmydocuments/:id"),
                  })}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <LightTooltip
                      title={leftNavbarOpen ? "" : " SmartDoc Library"}
                      placement="right"
                    >
                      <DescriptionOutlinedIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      SmartDoc Library
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                button
                // to="/grammarcheck"
                style={{ textDecoration: "none" }}
                // onClick={() => handleDocumentClick("grammarcheck")}
                onClick={() => {
                  handleDocumentClick("grammarcheck"); 
                  window.location.href = "/grammarcheck"; 
                }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]: isUrlMatch("/grammarcheck"),
                  })}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "Grammar Check"}
                      placement="right"
                    >
                      <SpellcheckIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      Grammar Check
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                button
                onClick={() => {
                  window.location.href = "/myteam";
                }}
                // to="/myteam"
                style={{ textDecoration: "none" }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]: isUrlMatch("/myteam"),
                  })}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "Team Hub"}
                      placement="right"
                    >
                      <GroupOutlinedIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      Team Hub
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                button
                // to="/coauthor"
                style={{ textDecoration: "none" }}
                // onClick={() => handleDocumentClick("coauthor")}
                onClick={() => {
                  handleDocumentClick("coauthor"); 
                  window.location.href = "/coauthor";
                }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]:
                      isUrlMatch("/coauthor") ||
                      isUrlMatch("/coauthor-newproject"),
                  })}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "Synthium Studio"}
                      placement="right"
                    >
                      <EditNoteIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      Synthium Studio
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                button
                onClick={() => {
                  window.location.href = "/reports";
                }}
                // to="/reports"
                style={{ textDecoration: "none" }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]: isUrlMatch("/reports"),
                  })}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "AI Intelligence"}
                      placement="right"
                    >
                      <AssessmentIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      AI Intelligence
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                button
                // to="/docTags"
                style={{ textDecoration: "none" }}
                onClick={() => {
                  handleTagsClick(); // keep your redux logic
                  window.location.href = "/docTags"; // force full reload
                }}
                // onClick={() => handleTagsClick()}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]:
                      isUrlMatch("/docTags") ||
                      isUrlMatch("/Summarizer") ||
                      isUrlMatch("/paraphrase") ||
                      isUrlMatch("/translator") ||
                      isUrlMatch("/plagiarism") ||
                      isUrlMatch("/citation"),
                  })}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "MultiTool AI"}
                      placement="right"
                    >
                      <LocalOfferIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      MultiTool AI
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                // to="/blogpage"
                style={{ textDecoration: "none" }}
                // onClick={handleBlogClick}
                onClick={() => {
                  handleBlogClick();
                  window.location.href = "/blogpage";
                }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]:
                      isUrlMatch("/blogpage") || isUrlMatch("/blogpreview/:id"),
                  })}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "Blogs"}
                      placement="right"
                    >
                      <FeedIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      Blogs
                    </Typography>
                  )}
                </ListItem>
              </ListItem>

              <ListItem
                // to="/faq"
                onClick={() => {
                  window.location.href = "/faq"; 
                }}
                style={{ textDecoration: "none" }}
              >
                <ListItem
                  className={clsx(classes.navItem, {
                    [classes.activeNavItem]: isUrlMatch("/faq"),
                  })}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <LightTooltip
                      title={leftNavbarOpen ? "" : "FAQ"}
                      placement="right"
                    >
                      <HelpOutlineIcon style={{ fontSize: 22 }} />
                    </LightTooltip>
                  </ListItemIcon>
                  {leftNavbarOpen && (
                    <Typography className={classes.listItemText}>
                      FAQ
                    </Typography>
                  )}
                </ListItem>
              </ListItem>
            </List>
          </div>
        </div>
      </Drawer>

      <main className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </main>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  isAuth: state.user.isAuth,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
  setUserFeatures: (features) => dispatch(setUserFeatures(features)),
  setRoleFeatures: (roleFeatures) => dispatch(setRoleFeatures(roleFeatures)),
  setSubscriptionPlan: (plan) => dispatch(setSubscriptionPlan(plan)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(NewHeader));
